function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
var _ref =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("path", {
  d: "M85 51.64c0 1.3-1.16 2.36-2.6 2.36H2.6C1.16 54 0 52.94 0 51.64V2.37C0 1.06 1.16 0 2.6 0h79.8C83.84 0 85 1.06 85 2.37v49.27z",
  fill: "#f1f2f2"
});
var _ref2 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("path", {
  d: "M30.68 38.9l4.05-23.76h6.48L37.15 38.9zm29.97-23.17c-1.28-.48-3.3-1-5.8-1-6.4 0-10.9 3.22-10.95 7.84-.03 3.4 3.22 5.32 5.68 6.46 2.52 1.17 3.37 1.9 3.36 2.95-.02 1.6-2.02 2.32-3.88 2.32-2.6 0-3.97-.36-6.1-1.24l-.83-.38-.9 5.32c1.5.66 4.3 1.24 7.22 1.27 6.8 0 11.23-3.2 11.28-8.12.03-2.7-1.7-4.76-5.44-6.45-2.27-1.1-3.65-1.83-3.64-2.95 0-1 1.17-2.04 3.7-2.04 2.12-.03 3.65.43 4.85.9l.58.27.88-5.16zm16.6-.56h-5c-1.55 0-2.7.42-3.4 1.97l-9.62 21.78h6.8l1.36-3.57 8.3.01.8 3.56h6l-5.24-23.75zm-8 15.32l2.58-6.64c-.04.06.53-1.38.86-2.27l.44 2.05 1.5 6.86h-5.38zm-44-15.32l-6.34 16.2-.68-3.3c-1.18-3.8-4.86-7.9-8.97-9.97l5.8 20.78h6.85l10.2-23.72h-6.86z",
  fill: "#00589f"
});
var _ref3 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("path", {
  d: "M13.03 15.15H2.58l-.08.5c8.13 1.97 13.5 6.72 15.73 12.43l-2.27-10.92c-.4-1.5-1.53-1.96-2.93-2h0z",
  fill: "#f9a51a"
});
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 85 54"
  }, props), _ref, _ref2, _ref3);
};
export default __webpack_public_path__ + "static/media/visa.2ff77e41.svg";
export { SvgComponent as ReactComponent };